<template>
  <admin-navbar>
    <div class="bg-white rounded shadow">
      <h6 class="text-base border-t-4 border-t-blue-500 rounded-t border-b p-3">
        Уулзалтын жагсаалт
      </h6>

      <div class="flex justify-between items-center p-3 text-xs">
        <div class="flex items-center gap-3">
          <label for="selectedType">Уулзалтын төлөв:</label>
          <select
            name="selectedType"
            id="selectedType"
            class="p-1 border rounded"
            v-model="selectedType"
          >
            <option value="" disabled>Хайлтын төрөл</option>
            <option value="all">Бүгд</option>
            <option value="accepted">Зөвшөөрсөн</option>
            <option value="pending">Хүлээгдэж байгаа</option>
            <option value="cancelled">Цуцласан</option>
          </select>
        </div>

        <div class="space-x-3">
          <span>Хуудас бүрт:</span>
          <select
            name="dataPerPage"
            id="dataPerPage"
            class="border rounded p-1 text-blue-500"
            v-model="dataPerPage"
          >
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>

        <span>Нийт уулзалтын тоо: {{ totalMeetingCount }} </span>

        <div class="flex items-center gap-3">
          <span>Нийт хуудас: {{ totalPages }} </span>
          <PaginationCart
            :totalPages="totalPages"
            :modelValue="currentPage"
            :style="{
              color: 'blue-500',
              height: 7,
              width: 7,
              fontSize: 'xs',
            }"
            @page-changed="onPageChanged"
          />
        </div>
      </div>

      <div
        v-if="meetings.length > 0 && !isLoading"
        class="p-3 space-y-5 text-xs min-h-[70vh]"
      >
        <YellowMeetingList :meetings="meetings" />
      </div>

      <div
        v-else-if="meetings.length === 0 && !isLoading"
        class="flex justify-center items-center h-[70vh]"
      >
        Хүсэлт хоосон байна
      </div>

      <div v-else class="flex justify-center items-center h-[70vh]">
        <SpinLoading />
      </div>
    </div>
  </admin-navbar>
</template>

<script>
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import { onMounted, ref, watch } from "vue";
import SpinLoading from "@/components/ui/SpinLoading.vue";
import adminInstance from "@/lib/adminInstance";
import PaginationCart from "@/components/ui/PaginationCart.vue";
import YellowMeetingList from "@/containers/YellowPage/admin/YellowMeetingList.vue";

export default {
  name: "AdminYellowMeetingList",
  components: {
    AdminNavbar,
    SpinLoading,
    PaginationCart,
    YellowMeetingList,
  },
  setup() {
    const isLoading = ref(false);
    const meetings = ref([]);
    const selectedType = ref("all");
    const dataPerPage = ref(20);
    const totalMeetingCount = ref(null);
    const totalPages = ref(1);
    const currentPage = ref(1);

    const fetchMeetings = async () => {
      try {
        isLoading.value = true;
        const res = await adminInstance.get(
          `/yellow-page/get/meetings?type=${selectedType.value}&page=${currentPage.value}&limit=${dataPerPage.value}`
        );
        meetings.value = res.data.meetings;
        totalPages.value = res.data.totalPages;
        totalMeetingCount.value = res.data.total;
      } catch (err) {
        return err;
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(async () => {
      await fetchMeetings();
    });

    watch([selectedType, dataPerPage], () => {
      currentPage.value = 1;
      fetchMeetings();
    });

    const onPageChanged = (page) => {
      currentPage.value = page;
      fetchMeetings();
    };

    return {
      isLoading,
      meetings,
      dataPerPage,
      totalMeetingCount,
      totalPages,
      currentPage,
      onPageChanged,
      selectedType,
      fetchMeetings,
    };
  },
};
</script>
